import PropTypes from 'prop-types';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import '@/components/menuSingleStore/menuSingleStore.scss';
import MemberIcon from '@components/member/components/memberIcon';
import DropDownMenu from '@components/member/ui/dropDownMenu';
import { ReactComponent as Cancel } from '@/assets/img/cancel.svg';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { Style } from '@/components/style';
import { ReactComponent as Notice } from '@/assets/img/notice.svg';
import { setShowMemberDropDown } from '@/actions/member/memberAction';
import StoreDetailModal from '@/components/common/storeDetail/storeDetailModal';
import MemberMenu from '@components/member/components/memberMenu';

const { secondaryColor } = new Style().getUiConfig();

function WelcomeHeader({ webStoreVo }) {
  const dispatch = useDispatch<any>();
  const showMemberDropDown = useSelector<RootStateOrAny, any>(
    (state) => state.memberReducer.showMemberDropDown
  );
  const [showStoreDetail, setShowStoreDetail] = useState(false);
  const handleClose = () => setShowStoreDetail(false);
  const handleShow = () => {
    setShowStoreDetail(true);
  };

  return (
    <div className="sticky-top zindex-sticky welcome-header-component-layout">
      <div id="welcome-single-store-header" style={{ zIndex: 4 }}>
        <div className="d-flex justify-content-between align-items-center pt-1">
          <div className="dropdown d-flex align-items-center">
            <div
              className="btn"
              data-testid="dropDownMenu"
              id="dropdown-menu"
              data-bs-toggle="dropdown"
              data-bs-auto-close="inside"
              aria-expanded="false"
              style={{
                padding: '0px',
                border: 'none',
                marginLeft: '-1px',
              }}
              onClick={() => {
                dispatch(setShowMemberDropDown(!showMemberDropDown));
              }}
            >
              <div
                className="d-flex align-items-center ms-3"
                style={{ height: '31px' }}
              >
                {showMemberDropDown ? <Cancel /> : <MemberIcon />}
              </div>
              <DropDownMenu>
                {webStoreVo?.uuid && <MemberMenu storeUuid={webStoreVo.uuid} />}
              </DropDownMenu>
            </div>
          </div>

          {/* 店家詳細資訊 */}
          {!showMemberDropDown && (
            <div
              className="d-flex align-items-center gap-1 me-3"
              style={{
                fontSize: '0.85rem',
                color: secondaryColor,
                // width: '100%',
                zIndex: 3,
              }}
              role="presentation"
              onClick={handleShow}
            >
              <Notice />
              <FormattedMessage id="storeDetail.store" />
            </div>
          )}
        </div>
      </div>

      {/* 店家詳細資訊Modal */}
      <StoreDetailModal
        webStoreVo={webStoreVo}
        show={showStoreDetail}
        handleClose={handleClose}
      />
    </div>
  );
}

WelcomeHeader.propTypes = {
  webStoreVo: PropTypes.shape({}).isRequired,
};

export default WelcomeHeader;
